import s from "./line_chart_selector.module.css";

export default function LineChartSelector(props) {
  const { onClick, mode = "all" } = props;
  return (
    <div className={s.wrapper}>
      <div className={mode === "all" ? s.active_left : s.left} onClick={() => onClick("all")}>
        ALL TIME
      </div>
      <div className={mode === "year" ? s.active_right : s.right} onClick={() => onClick("year")}>
        LAST YEAR
      </div>
      <div className={mode === "6months" ? s.active_right : s.right} onClick={() => onClick("6months")}>
        6 MONTHS
      </div>
      <div className={mode === "3months" ? s.active_right : s.right} onClick={() => onClick("3months")}>
        3 MONTHS
      </div>
      <div className={mode === "30days" ? s.active_right : s.right} onClick={() => onClick("30days")}>
        30 DAYS
      </div>
    </div>
  );
}
